import React from 'react';
var VideoEmbedder = function (_a) {
    var url = _a.url;
    return (React.createElement("div", { className: "lfc-bg-[#D9D9D9] lfc-rounded-lg lfc-w-full lfc-h-full lfc-pb-[47.65625%] lfc-relative" },
        React.createElement("iframe", { src: url, allowFullScreen: true, className: "lfc-absolute lfc-top-0 lfc-left-0 lfc-w-full lfc-h-full lfc-rounded-lg" })));
};
export default VideoEmbedder;
//# sourceMappingURL=VideoEmbedder.js.map